import type { IOrgRepository, OrgUpdateInput } from '../repositories/IOrgRepository.js';
import type { OrgEntity } from '../entities/OrgEntity.js';

export interface UpdateOrgInput {
  id: string;
  input: OrgUpdateInput;
}

interface Dependencies {
  orgRepository: IOrgRepository;
}

export function createUpdateOrgUseCase({ orgRepository }: Dependencies) {
  return async function updateOrg(payload: UpdateOrgInput): Promise<OrgEntity | null> {
    return orgRepository.update(payload.id, payload.input);
  };
}
